import { forwardRef } from "react";
import { cn } from "@/lib/cn";
import { useMediaLazyLoad } from "@/shared";
import { useTickerCtx } from "../ctx";
import { getTickerAnimSpeed } from "../utils";
import { TickerItem } from "./ticker-item";

export const TickerItems = forwardRef<HTMLDivElement>((_, ref) => {
  const {
    shouldAnimate,
    isAnimReverse,
    isHorizontal,
    isVertical,
    elementSettings,
  } = useTickerCtx();
  const { tickerItems } = elementSettings;
  const { setObserverRef, isVisible } = useMediaLazyLoad();

  const animSpeed = getTickerAnimSpeed(elementSettings.tickerAnimSpeed);
  return (
    <div
      ref={setObserverRef}
      className={cn("ticker-scroll-wrapper tw-absolute tw-overflow-hidden", {
        "tw-left-0 tw-mx-auto tw-inline-flex": isHorizontal,
        "tw-w-full tw-justify-center": !shouldAnimate && isHorizontal,
        "tw-left-0 tw-flex tw-h-max tw-w-full tw-flex-col": isVertical,
      })}
      data-should-animate={shouldAnimate}
      style={{
        animationDirection: isAnimReverse ? "reverse" : "normal",
        animationDuration: `${tickerItems.length * 2 * animSpeed}ms`,
        // @ts-expect-error
        "--ticker-anim-goal-x": isHorizontal ? "-50%" : "0%",
        "--ticker-anim-goal-y": isVertical ? "-50%" : "0%",
      }}
    >
      <div
        ref={ref}
        className={cn("tw-flex", {
          "tw-w-full tw-flex-col tw-items-center": isVertical,
        })}
      >
        {tickerItems.map((item, idx) => (
          <TickerItem
            key={item.id}
            idx={idx}
            item={item}
            isVisible={isVisible}
          />
        ))}
      </div>

      {shouldAnimate && (
        <div
          className={cn("tw-flex", {
            "tw-w-full tw-flex-col tw-items-center": isVertical,
          })}
        >
          {tickerItems.map((item, idx) => (
            <TickerItem
              key={item.id}
              item={item}
              idx={idx}
              isVisible={isVisible}
            />
          ))}
        </div>
      )}
    </div>
  );
});
